import React from "react";
import "./ComparisonSectionAICreator.scss";

const ComparisonSectionAICreator = () => {
  const title = "Why ALL3D is better than other AI solutions";
  const sub_title = "Other AI solutions struggle to deliver pixel-level product accuracy and scene control.";

  const comparisonData = [
    {
      header: "ALL3D",
      icon: "/smb/CheckCircle.svg",
      features: [
        "Precise product scale, color, and texture",
        "Realistic placement in scenes",
        "On-brand image styling through trained AI models",
        "Optimized for user control",
        "4x better resolution"
      ],
      imgs: [
        "",
        "",
        "",
        "",
        ""
      ],
    },
    {
      header: "Other AI",
      icon: "/smb/CloseCircle.svg",
      features: [
        "Inaccurate product details",
        "Unrealistic placement",
        "No brand guidelines",
        "Less user control",
        "Models trained on 1k images"
      ],
    },
  ];

  const comparisonDataMobile = [
    {
      header: "ALL3D",
      icon: "/smb/CheckCircle.svg",
      features: [
        "Precise product scale, color, and texture",
        "Realistic placement in scenes",
        "On-brand image styling through trained AI models",
        "Optimized for user control",
        "4x better resolution"
      ],
      imgs: [
        "",
        "",
        "",
        "",
        ""
      ],
    },
    {
      header: "Other AI",
      icon: "/smb/CloseCircle.svg",
      features: [
        "Inaccurate product details",
        "Unrealistic placement",
        "No brand guidelines",
        "Less user control",
        "Models trained on 1k images"
      ],
    },
  ];

  return (
    <div className="comparison-section-ai-creator" id="#comparison">
      <WebVersion 
        title={title} 
        sub_title={sub_title} 
        comparisonData={comparisonData}
      />
      <MobileVersion 
        title={title} 
        sub_title={sub_title} 
        comparisonData={comparisonDataMobile}
      />
    </div>
  );
};

const WebVersion = ({ title, sub_title, comparisonData }) => {
  return (
    <div className="d-none d-lg-block" id="web">
      <div className="section-wrapper">
        <div className="d-flex flex-column d-lg-mb-3" id="comparison-Title">
          <h1 className="manrope f-38 w-600 lh-46 white text-center comparison-title">{title}</h1>
          <p className="manrope f-16 lh-24 w-500 white text-center mb-32">
            {sub_title}
          </p>
        </div>
        <div className="comparison-table">
          <div className="comparison-column-web">
            {comparisonData[0].features.map((points, index) => (
              <div className="comparison-cell" key={index}>
                <p className="manrope f-16 w-700 lh-24 black-085 justify-space-between">{points}
                  {comparisonData[0].imgs[index] === "" ? "" :
                    <img className="benefits-icon" src={comparisonData[0].imgs[index]} alt="" />}</p>
              </div>
            ))}
          </div>
          <div className="comparison-column">
            <div className="comparison-header">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {comparisonData[0].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper">
              {comparisonData[0].features.map((points, index) => (
                <div
                  className="comparison-cell justify-content-center"
                  key={index}
                >
                  <img
                    className="comparison-icon"
                    src={comparisonData[0].icon}
                    alt="icon"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="comparison-column">
            <div className="comparison-header-2">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {comparisonData[1].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper second">
              {comparisonData[1].features.map((points, index) => (
                <div className="comparison-cell" key={index}>
                  <img
                    className="comparison-icon mr-2"
                    src={comparisonData[1].icon}
                    alt="icon"
                  />
                  <p className="manrope f-14 w-500 lh-22 black-085">{points}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const MobileVersion = ({ title, sub_title, comparisonData }) => {
  return (
    <div className="d-lg-none" id="mobile">
      <div className="section-wrapper">
        <div className="d-flex flex-column">
          <h1 className="manrope f-30 w-600 lh-40 white text-center mb-16">{title}</h1>
          <p className="manrope f-16 w-500 lh-24 white text-center">
            {sub_title}
          </p>
        </div>
        <div className="comparison-table">
          <div className="comparison-column">
            <div className="comparison-header">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {comparisonData[0].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper first">
              {comparisonData[0].features.map((points, index) => (
                <div className="comparison-cell" key={index}>
                  <img
                    className="comparison-icon mb-2"
                    src={comparisonData[0].icon}
                    alt="icon"
                  />
                  <p className="manrope f-14 w-500 lh-22 black-085 text-center">
                    {points}
                    {comparisonData[0].imgs[index] === "" ? "" :
                      <img className="benefits-icon mt-8" src={comparisonData[0].imgs[index]} alt="" />}
                  </p>

                </div>
              ))}
            </div>
          </div>
          <div className="comparison-column">
            <div className="comparison-header-2">
              <h2 className="manrope f-16 w-700 lh-24 white text-center mb-0">
                {comparisonData[1].header}
              </h2>
            </div>
            <div className="comparison-cell-wrapper second">
              {comparisonData[1].features.map((points, index) => (
                <div className="comparison-cell" key={index}>
                  <img
                    className="comparison-icon mb-2"
                    src={comparisonData[1].icon}
                    alt="icon"
                  />
                  <p className="manrope f-14 w-500 lh-22 black-085 text-center">
                    {points}
                  </p>

                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComparisonSectionAICreator;
